import React, { useState, useEffect, useCallback, useMemo } from "react";
import { connect } from "react-redux";

import AddButton from "../../../../ui/AddButton";
import OutsideClickHandler from "react-outside-click-handler";
import { withStyles } from "@material-ui/core/styles";

import Box from "../../../../ui/Box";

import ModuleInfoDrawer from "../ModuleInfoDrawer";
import InfoDrawer from "../../../../ui/InfoDrawer";
import DeleteConfirmationModal from "../../../../ui/DeleteConfirmationModal";
import {
  addNewModuleInformationAction,
  deleteModuleAction,
  getAllModuleListAction
} from "../../store/actions";

import QueryTable from "../../../../ui/QueryTable";
import useQuery from "../../../../ui/QueryTable/useQuery";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

const ModuleTable = ({ newModuleId, addNewModule, deleteModule, history }) => {
  const [selectedModule, setSelectedModule] = useState([]);
  const [deleteConfimationOpen, setDeleteConfimationOpen] = useState(false);
  const [focusedModule, setFocusedModule] = useState(-1);

  const query = useQuery(2);
  useEffect(() => {
    query.load();
  }, []);

  useEffect(() => {
    if (newModuleId) {
      history.push(`/work/app/constructor/edit-module/${newModuleId}`);
    }
  }, [history, newModuleId]);

  const onRowClick = useCallback(e => {
    const focusedModule = e !== -1 ? e.data.id : e;
    setFocusedModule(focusedModule);
  }, []);

  const selectModule = useCallback(({ selectedRowsData }) => {
    setSelectedModule(selectedRowsData);
  }, []);

  const removeModule = useCallback(() => {
    const moduleIdList = selectedModule.map(({ id }) => id);
    deleteModule(moduleIdList);
    setDeleteConfimationOpen(false);
  }, [deleteModule, selectedModule]);

  const primaryActions = useCallback(() => {
    addNewModule();
  }, [addNewModule]);

  const secondaryActions = useMemo(() => {
    return [
      {
        label:
          selectedModule.length > 1
            ? "Удалить выбранные модули"
            : "Удалить выбранный модуль",
        onClick: () => setDeleteConfimationOpen(true),
        disabled: selectedModule.length === 0
      }
    ];
  }, [selectedModule.length]);

  return (
    <>
      <DeleteConfirmationModal
        open={deleteConfimationOpen}
        onConfirm={removeModule}
        handleClose={() => setDeleteConfimationOpen(false)}
        modalText={
          selectedModule.length > 1
            ? "Удалить выбранные модули?"
            : "Удалить выбранный модуль?"
        }
      />
      <Box>
        <QueryTable
          focusedId={focusedModule}
          onSelectionChanged={selectModule}
          onRowClick={onRowClick}
          primaryActions={<AddButton onClick={primaryActions} />}
          secondaryActions={secondaryActions}
          {...query}
        />
      </Box>
      <OutsideClickHandler onOutsideClick={() => onRowClick(-1)}>
        <InfoDrawer open={focusedModule !== -1}>
          <ModuleInfoDrawer moduleId={focusedModule} />
        </InfoDrawer>
      </OutsideClickHandler>
    </>
  );
};

const mapStateToProps = state => ({
  moduleInformation: state.modules.moduleInformation,
  newModuleId: state.modules.newModuleInformation.id
});

const mapDispatchToProps = dispatch => ({
  addNewModule: () => dispatch(addNewModuleInformationAction()),
  deleteModule: idList => dispatch(deleteModuleAction(idList)),
  getModulesList: () => dispatch(getAllModuleListAction())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ModuleTable));
